export const features = [
  {
    title: 'Real-Time Order Tracking',
    description: 'Monitor every purchase across all product categories in one unified spreadsheet dashboard. Track order status, shipping updates, and delivery confirmations without switching between multiple platforms.',
    icon: 'ri-line-chart-line',
  },
  {
    title: '14 Product Categories',
    description: 'Browse and manage products across Shoes, Hoodies, T-Shirts, Jackets, Pants, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and more — all organized in a single system.',
    icon: 'ri-store-2-line',
  },
  {
    title: 'Auto-Sync & Export',
    description: 'Automatically synchronize your order data and export reports with one click. The spreadsheet system eliminates manual data entry and reduces errors across your entire purchasing workflow.',
    icon: 'ri-refresh-line',
  },
];

export const spreadsheetComparison = [
  { system: 'GTBuy Spreadsheet', ease: 'High', automation: 'High', bestFor: 'Business users' },
  { system: 'Kakobuy Spreadsheet', ease: 'Medium', automation: 'Medium', bestFor: 'Beginners' },
  { system: 'Superbuy Spreadsheet', ease: 'High', automation: 'High', bestFor: 'Advanced users' },
];

export const howItWorks = [
  { step: '01', title: 'Choose Your Spreadsheet System', description: 'Select from GTBuy, Kakobuy, or Superbuy spreadsheet systems based on your workflow needs.' },
  { step: '02', title: 'Connect Your Shopping Workflow', description: 'Link your product categories and start tracking orders across all your favorite storefronts.' },
  { step: '03', title: 'Track & Automate Orders', description: 'Use built-in spreadsheet formulas to automate tracking, reduce manual work, and eliminate errors.' },
  { step: '04', title: 'Optimize Performance', description: 'Analyze your purchasing patterns and optimize your shopping workflow for maximum efficiency.' },
];